const initialState = {
  batches: [],
  previewData: null,
  selectedBatch: null,
  serialDetails: null,
  traceability: null,
  traceabilityLoading: false,
  traceabilityError: null,
  loading: false,
  actionLoading: false,
  previewLoading: false,
  warrantyLookup: null,
  extendResult: null,
  extensionLogs: {}, // { serialNo: [...logs] }
  warrantyLoading: false,
  extendLoading: false,
  error: null
};

const QRBatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GENERATE_QR_PREVIEW_REQUEST':
      return { ...state, previewLoading: true, error: null };
    case 'GENERATE_QR_PREVIEW_SUCCESS':
      return { ...state, previewLoading: false, previewData: action.payload, error: null };
    case 'GENERATE_QR_PREVIEW_FAILURE':
      return { ...state, previewLoading: false, error: action.payload };

    case 'CONFIRM_BATCH_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CONFIRM_BATCH_SUCCESS':
      // Root cause of the stale-preview bug: this used to leave previewData
      // untouched after a save, so the QR grid / print output could still show
      // an older product's preview while a different batch had just been saved.
      // The confirm response is the source of truth for what was actually
      // persisted, so previewData is replaced with it (not just cleared) —
      // this keeps the "Batch Confirmed & Saved" grid and Print accurate.
      return {
        ...state,
        actionLoading: false,
        batches: [action.payload, ...state.batches],
        previewData: action.payload,
        error: null
      };
    case 'CONFIRM_BATCH_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'FETCH_BATCHES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_BATCHES_SUCCESS':
      return { ...state, loading: false, batches: action.payload, error: null };
    case 'FETCH_BATCHES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_BATCH_DETAILS_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_BATCH_DETAILS_SUCCESS':
      return { ...state, actionLoading: false, selectedBatch: action.payload, error: null };
    case 'GET_BATCH_DETAILS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'GET_SERIAL_DETAILS_REQUEST':
      return { ...state, actionLoading: true, serialDetails: null, error: null };
    case 'GET_SERIAL_DETAILS_SUCCESS':
      return { ...state, actionLoading: false, serialDetails: action.payload, error: null };
    case 'GET_SERIAL_DETAILS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'GENERATE_SERIALS_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GENERATE_SERIALS_SUCCESS':
      return { ...state, actionLoading: false, error: null };
    case 'GENERATE_SERIALS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CLEAR_QR_PREVIEW':
      return { ...state, previewData: null };

    case 'GET_SERIAL_TRACEABILITY_REQUEST':
      return { ...state, traceabilityLoading: true, traceability: null, traceabilityError: null };
    case 'GET_SERIAL_TRACEABILITY_SUCCESS':
      return { ...state, traceabilityLoading: false, traceability: action.payload, traceabilityError: null };
    case 'GET_SERIAL_TRACEABILITY_FAILURE':
      return { ...state, traceabilityLoading: false, traceability: null, traceabilityError: action.payload };
    case 'CLEAR_SERIAL_TRACEABILITY':
      return { ...state, traceability: null, traceabilityError: null };

    case 'WARRANTY_LOOKUP_REQUEST':
      return { ...state, warrantyLoading: true, warrantyLookup: null, error: null };
    case 'WARRANTY_LOOKUP_SUCCESS':
      return { ...state, warrantyLoading: false, warrantyLookup: action.payload };
    case 'WARRANTY_LOOKUP_FAILURE':
      return { ...state, warrantyLoading: false, error: action.payload };
    case 'EXTEND_WARRANTY_REQUEST':
      return { ...state, extendLoading: true, extendResult: null, error: null };
    case 'EXTEND_WARRANTY_SUCCESS':
      return { ...state, extendLoading: false, extendResult: action.payload };
    case 'EXTEND_WARRANTY_FAILURE':
      return { ...state, extendLoading: false, error: action.payload };
    case 'GET_EXT_LOGS_REQUEST':
      return { ...state };
    case 'GET_EXT_LOGS_SUCCESS':
      return {
        ...state,
        extensionLogs: { ...state.extensionLogs, [action.payload.serialNo]: action.payload.logs }
      };
    case 'GET_EXT_LOGS_FAILURE':
      return { ...state };

    default:
      return state;
  }
};

export default QRBatchReducer;
